// src/mocks/accounts/factory.js

const collectionAccounts = [
  {
    id: 'account1',
    name: 'Votafone',
    logoUrl: 'https://logoipsum.com/logo/logo-14.svg'
  },
  {
    id: 'account2',
    name: 'Emerlia',
    logoUrl: 'https://logoipsum.com/logo/logo-13.svg'
  },
  {
    id: 'account99',
    name: 'Nss',
    logoUrl: 'https://logoipsum.com/logo/logo-15.svg'
  },
  {
    id: 'account100',
    name: 'Agency',
    logoUrl: 'https://logoipsum.com/logo/logo-15.svg'
  }
]

const collectionLeadsByAccounts = [
  {
    // Lead 1 → Cliente "Acomp"
    id: "lead1",
    date: "2025-05-21 08:30:00",
    phone: "600111222",
    idLeadCti: "100",
    firstName: "Lucía",
    lastName: "Gómez",
    email: "lucia.gomez@example.com",
    campaignName: "Primavera 2025",
    leadStatus: "Nuevo",
    callCenterName: "Central A",
    customerName: "Acomp",
    providerName: "Ignium",
    category: "A",
    cta: "Form",
    serviceIdDestination: "2001",
    statusCti: "OK",
    utmSource: "Facebook",
    utmCampaign: "CampañaSocial",
    utmMedium: "paid",
    idLeadSource: "LS100",
    visitorId: "V100",
    fullname: "Lucía Gómez",
    agentId: "A100",
    agentName: "Sofía",
    agentType: "ADM",
    agentSupervisorName: "Mario Ruiz",
    agentProvince: "MADRID",
    agentProducts: "Crédito",
    formProvider: "FacebookAds",

    // Campos para la tabla
    leadId: "lead1",
    createdAt: "2025-05-21T08:30:00Z",
    leadCTIId: "100",
    secondName: "Gómez",
    campaign: "Primavera 2025",
    state: "Nuevo",
    callCenter: "Central A",
    customer: "Acomp",
    provider: "Ignium",
    service: "2001",
    statusCTI: "OK",
    leadSourceId: "LS100",
    visitorId: "V100",
    fullName: "Lucía Gómez",
    agentSupervisor: "Mario Ruiz"
  },
  {
    // Lead 2 → Cliente "Infocomp"
    id: "lead2",
    date: "2025-05-20 14:15:00",
    phone: "600333444",
    idLeadCti: "101",
    firstName: "Óscar",
    lastName: "Martínez",
    email: "oscar.martinez@example.com",
    campaignName: "Verano 2025",
    leadStatus: "Contactado",
    callCenterName: "Central B",
    customerName: "Infocomp",
    providerName: "TelcoX",
    category: "B",
    cta: "Inbound",
    serviceIdDestination: "2002",
    statusCti: "PEND",
    utmSource: "Google",
    utmCampaign: "AdsVerano",
    utmMedium: "cpc",
    idLeadSource: "LS101",
    visitorId: "V101",
    fullname: "Óscar Martínez",
    agentId: "A101",
    agentName: "Laura",
    agentType: "SUP",
    agentSupervisorName: "Ana Pérez",
    agentProvince: "VALENCIA",
    agentProducts: "Internet",
    formProvider: "GoogleAds",

    leadId: "lead2",
    createdAt: "2025-05-20T14:15:00Z",
    leadCTIId: "101",
    secondName: "Martínez",
    campaign: "Verano 2025",
    state: "Contactado",
    callCenter: "Central B",
    customer: "Infocomp",
    provider: "TelcoX",
    service: "2002",
    statusCTI: "PEND",
    leadSourceId: "LS101",
    visitorId: "V101",
    fullName: "Óscar Martínez",
    agentSupervisor: "Ana Pérez"
  },
  {
    // Lead 3 → Cliente "PTV"
    id: "lead3",
    date: "2025-05-19 09:00:00",
    phone: "600555666",
    idLeadCti: "102",
    firstName: "María",
    lastName: "López",
    email: "maria.lopez@example.com",
    campaignName: "Otoño 2025",
    leadStatus: "EnviadoDispatcher",
    callCenterName: "Central C",
    customerName: "PTV",
    providerName: "NetCorp",
    category: "C",
    cta: "Form",
    serviceIdDestination: "2003",
    statusCti: "OK",
    utmSource: "Twitter",
    utmCampaign: "TweetPromo",
    utmMedium: "social",
    idLeadSource: "LS102",
    visitorId: "V102",
    fullname: "María López",
    agentId: "A102",
    agentName: "David",
    agentType: "ADM",
    agentSupervisorName: "Clara Ruiz",
    agentProvince: "SEVILLA",
    agentProducts: "Móvil",
    formProvider: "TwitterAds",

    leadId: "lead3",
    createdAt: "2025-05-19T09:00:00Z",
    leadCTIId: "102",
    secondName: "López",
    campaign: "Otoño 2025",
    state: "EnviadoDispatcher",
    callCenter: "Central C",
    customer: "PTV",
    provider: "NetCorp",
    service: "2003",
    statusCTI: "OK",
    leadSourceId: "LS102",
    visitorId: "V102",
    fullName: "María López",
    agentSupervisor: "Clara Ruiz"
  },
  {
    // Lead 4 → Cliente "Acomp" (duplicado)
    id: "lead4",
    date: "2025-05-18 17:45:00",
    phone: "600777888",
    idLeadCti: "103",
    firstName: "Jorge",
    lastName: "Sánchez",
    email: "jorge.sanchez@example.com",
    campaignName: "Invierno 2025",
    leadStatus: "Pendiente",
    callCenterName: "Central D",
    customerName: "Acomp",
    providerName: "FiberWeb",
    category: "A",
    cta: "Inbound",
    serviceIdDestination: "2004",
    statusCti: "PEND",
    utmSource: "LinkedIn",
    utmCampaign: "LinkedPromo",
    utmMedium: "paid",
    idLeadSource: "LS103",
    visitorId: "V103",
    fullname: "Jorge Sánchez",
    agentId: "A103",
    agentName: "Marta",
    agentType: "SUP",
    agentSupervisorName: "Luis Gómez",
    agentProvince: "BILBAO",
    agentProducts: "TV",
    formProvider: "LinkedInAds",

    leadId: "lead4",
    createdAt: "2025-05-18T17:45:00Z",
    leadCTIId: "103",
    secondName: "Sánchez",
    campaign: "Invierno 2025",
    state: "Pendiente",
    callCenter: "Central D",
    customer: "Acomp",
    provider: "FiberWeb",
    service: "2004",
    statusCTI: "PEND",
    leadSourceId: "LS103",
    visitorId: "V103",
    fullName: "Jorge Sánchez",
    agentSupervisor: "Luis Gómez"
  }
]

const showAccounts  = collectionAccounts
const indexAccounts = collectionAccounts
const leadsAccounts = collectionLeadsByAccounts

export { indexAccounts, showAccounts, leadsAccounts }
